var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__media"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/calculadora.jpeg"),"alt":_vm.titulo}})]),_c('div',{staticClass:"header__title container"},[_c('h1',[_vm._v(_vm._s(_vm.titulo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }